import { TW_BUTTON_BASE } from '../VButton';
import { createTwStyle, joinCn, new__cn } from '../util';
import { TEXT_BUTTON_SIZE, TEXT_BUTTON_VARIANT } from './constant';
import type { VTextButtonProps } from './type';

const TW_TEXT_BUTTON_SIZE = {
  [TEXT_BUTTON_SIZE.XS]: joinCn(
    'px-scale/4 py-scale/2',
    'text-body-sm',
    '[&_svg]:size-3',
  ),
  [TEXT_BUTTON_SIZE.SM]: joinCn(
    'px-scale/8 py-scale/4',
    'text-body-md',
    '[&_svg]:size-4',
  ),
  [TEXT_BUTTON_SIZE.MD]: joinCn(
    'px-scale/8 py-scale/4',
    'text-body-lg',
    '[&_svg]:size-4',
  ),
} as const;

const TW_TEXT_BUTTON_VARIANT = {
  [TEXT_BUTTON_VARIANT.PRIMARY]: joinCn(
    'text-gray-500',
    'enabled:hover:text-gray-400',
    'enabled:active:text-gray-600',
  ),
  [TEXT_BUTTON_VARIANT.DANGER]: joinCn(
    'text-error-500',
    'enabled:hover:text-error-400',
    'enabled:active:text-error-600',
  ),
} as const;

export const TW_TEXT_BUTTON_BASE = new__cn(
  TW_BUTTON_BASE,
  'rounded-md',
  'font-semibold',

  'aria-busy:bg-white aria-busy:hover:bg-white',
);

const twStyle = createTwStyle<VTextButtonProps>();

export default twStyle({
  textButton: ({
    fluid,
    size = TEXT_BUTTON_SIZE.SM,
    variant = TEXT_BUTTON_VARIANT.PRIMARY,
  }) => {
    return joinCn(
      TW_TEXT_BUTTON_BASE,
      TW_TEXT_BUTTON_SIZE[size],
      TW_TEXT_BUTTON_VARIANT[variant],
      fluid ? 'w-full' : 'w-fit',
    );
  },
});
